import React from 'react';
import { FormattedMessage, injectIntl } from "react-intl";
import '../../eingabe/Eingabe.css';
import Kulissengewichtberechnung from "../../gewichtsberechnung/Kulissengewichtberechnung";
import Kulissenpreis from "../../preisberechnung/Kulissenpreis";
import ZusatzoptionenPreis from "../../preisberechnung/ZusatzoptionenPreis";
import { formatEuroPrice } from "../../utils/formatEuroPrice";
import { getPdfDownloadFileName } from "../../utils/windowsFileName";
import { getKulissenBestellschluessel } from "../../utils/kulissenBestellschluessel";
import LinkKopieren from "../../eingabe/LinkKopieren";

class AusgabeKulissenwerte extends React.Component {
       constructor(props) {
    super(props);
    this.state = {
        kulissengewicht: 0,
        kulissenpreis: 0,
        preisZusatzoptionenKulisse:0,
        isPdfDownloadPreparing: false,
        //kulissenanzahl : 1,
    };
    this.handleInputChange= this.handleInputChange.bind(this);
    this.handlekulissengewichtChange = this.handlekulissengewichtChange.bind(this);
    this.handleKulissenpreisChange = this.handleKulissenpreisChange.bind(this);
    this.handlePreisZusatzoptionenKulisseChange = this.handlePreisZusatzoptionenKulisseChange.bind(this);
    this.handlePdfDownload = this.handlePdfDownload.bind(this);
    // this.getSelectedKulissentypHandler = this.getSelectedKulissentypHandler.bind(this);
    // this.getSelectedKulissenbreiteHandler = this.getSelectedKulissenbreiteHandler.bind(this);
    // this.onKeyUp = this.onKeyUp.bind(this);
  }

    handlekulissengewichtChange(e) {

        if(e !== this.state.kulissengewicht){
            this.setState({kulissengewicht: e});
        };
    }

    handlePreisZusatzoptionenKulisseChange(value){
        if(value !== this.state.preisZusatzoptionenKulisse){
            this.setState({preisZusatzoptionenKulisse:value})
        }
    }

  handleInputChange(event) {
    const target = event.target;
    const value = target.name === 'isGoing' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value    });
  }

  handleKulissenpreisChange(value){
      if(value !== this.state.kulissenpreis){
          this.setState({kulissenpreis:value})
      }
  }

  onKeyUp(event) {
      if (event.key === "Enter") {
          this.handleInputChange(event);
      }
  }

  rabattberechnung(){
     let rabattpreis = 0;
     // console.log("Kulissenpreis: " + this.state.kulissenpreis)
     // console.log("Rabatt" + this.props.Rabatt)
     if(this.props.Rabatt >0) {
         rabattpreis = this.state.kulissenpreis - (this.state.kulissenpreis * this.props.Rabatt / 100) + this.state.preisZusatzoptionenKulisse
         // console.log("Rabattpreis: "+ rabattpreis);
         return rabattpreis.toFixed(2);
     }
     else{
         let preis =  this.state.kulissenpreis + this.state.preisZusatzoptionenKulisse
         return preis.toFixed(2);
     }
  }
  preisberechnung(){
      let preis =  this.state.kulissenpreis + this.state.preisZusatzoptionenKulisse
      return preis.toFixed(2);
  }

  // Numerischer Gesamtpreis (inkl. Rabatt und Zusatzoptionen) für das PDF –
  // nutzt dieselbe Logik wie die Anzeige (rabattberechnung/preisberechnung).
  kulissenpreisNetto(){
      return Number(this.props.Rabatt > 0 ? this.rabattberechnung() : this.preisberechnung());
  }

  // Erzeugt das PDF-Datenblatt für die Einzelkulisse und lädt es herunter –
  // analog zur Schalldämpfer-Berechnung. Der @react-pdf/renderer und die
  // PDF-Komponente werden erst beim Klick dynamisch geladen, damit die
  // Formularseite nicht unnötig blockiert wird.
  async handlePdfDownload(){
      if (this.state.isPdfDownloadPreparing) {
          return;
      }
      this.setState({ isPdfDownloadPreparing: true });

      if (typeof window !== "undefined" && !window.process) {
          window.process = { env: { NODE_ENV: "production" } };
      }

      try {
          const [pdfRenderer, datenblattModule] = await Promise.all([
              import("@react-pdf/renderer"),
              import("../../pdf/KulissenDatenblatt"),
          ]);
          const pdf = pdfRenderer.pdf || (pdfRenderer.default && pdfRenderer.default.pdf);
          const KulissenDatenblatt = datenblattModule.default;

          const bestellschluessel = getKulissenBestellschluessel({
              Kulissentyp: this.props.Kulissentyp,
              Kulissenbreite: this.props.Kulissenbreite,
              Kulissenhoehe: this.props.Kulissenhoehe,
              Kulissenlaenge: this.props.Kulissenlaenge,
          });

          const blob = await pdf(
              <KulissenDatenblatt
                  currentLocale={this.props.intl.locale}
                  Bestellschluessel={bestellschluessel}
                  Kulissentyp={this.props.Kulissentyp}
                  Kulissenbreite={this.props.Kulissenbreite}
                  Kulissenhoehe={this.props.Kulissenhoehe}
                  Kulissenlaenge={this.props.Kulissenlaenge}
                  Gewicht={this.state.kulissengewicht.toFixed(2)}
                  Preis={this.kulissenpreisNetto()}
                  PreisAufAnfrage={this.state.kulissenpreis <= 0}
                  Rabatt={this.props.Rabatt}
              />
          ).toBlob();

          const url = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = getPdfDownloadFileName(bestellschluessel);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
      } finally {
          this.setState({ isPdfDownloadPreparing: false });
      }
  }

  render() {

     return (
     <>
      <div className={"form-style-8"}>
        <h2><FormattedMessage id="Kulisse" /></h2>
        {/*<h3><label htmlFor={"Bestellschluessel"}>Bestellschlüssel: </label></h3>*/}
        {/*<p>*/}
        {/*  <BestellschluesselSchalldaempfer id={"Bestellschluessel"} Kulissentyp={this.props.Kulissentyp} Kulissenbreite={this.props.Kulissenbreite} Kulissenanzahl={this.props.AnzahlKulissen}  SelectedAnschlussprofil={this.props.SelectedAnschlussprofil} Schalldaempferbreite={this.props.Schalldaempferbreite} Schalldaempferhoehe={this.props.Schalldaempferhoehe} Schalldaempferlaenge={this.props.Schalldaempferlaenge} Kulissenspaltbreite={this.state.kulissenspaltbreite} />*/}
        {/*</p>*/}

        <h3><label><FormattedMessage id="Kulissentyp" />: </label></h3>
        <p>
           {this.props.Kulissentyp}
        </p>

        <h3><label><FormattedMessage id="Kulissenbreite" />: </label></h3>
        <p>
           {this.props.Kulissenbreite}<span> mm</span>
        </p>
        <h3><label><FormattedMessage id="Kulissenhoehe" />: </label></h3>
        <p>
           {this.props.Kulissenhoehe}<span> mm</span>
        </p>
        <h3><label><FormattedMessage id="Kulissenlaenge" />: </label></h3>
        <p>
           {this.props.Kulissenlaenge}<span> mm</span>
        </p>

        <h3><label><FormattedMessage id="Kulissengewicht" />: </label></h3>
        <p>
           {this.state.kulissengewicht.toFixed(2)}<Kulissengewichtberechnung  Kulissenbreite={this.props.Kulissenbreite} Kulissenlaenge={this.props.Kulissenlaenge}  Kulissenhoehe={this.props.Kulissenhoehe} Kulissentyp={this.props.Kulissentyp} handlekulissengewichtChange={this.handlekulissengewichtChange}/><span> kg</span>
        </p>
        <h3><label>{this.props.Rabatt > 0 ? <FormattedMessage id="Preis_mit_Rabatt" values={{ n: this.props.Rabatt }} /> : <FormattedMessage id='Preis'/> }</label></h3>
        <p>
            <strong>
                <ZusatzoptionenPreis Kulissenbreite={this.props.Kulissenbreite}
                                         Kulissenhoehe={this.props.Kulissenhoehe}
                                         Kulissenlaenge={this.props.Kulissenlaenge}
                                         Rabatt={this.props.Rabatt}
                                         KulissenpreisNetto={this.state.kulissenpreis}
                                         Optionen={this.props.Optionen}
                                         ZusatzoptionenpreisChange={this.handlePreisZusatzoptionenKulisseChange}
                />
                <Kulissenpreis Kulissenbreite={this.props.Kulissenbreite}
                                    Kulissenhoehe={this.props.Kulissenhoehe}
                                    Kulissenlaenge={this.props.Kulissenlaenge} Kulissentyp={this.props.Kulissentyp}
                                    KulissenpreisChange={this.handleKulissenpreisChange}
                                    Optionen={this.props.Optionen} />
                {/*<Kulissenpreis Kulissenbreite={this.props.Kulissenbreite}*/}
                {/*               Kulissenhoehe={this.props.Kulissenhoehe}*/}
                {/*               Kulissenlaenge={this.props.Kulissenlaenge} Kulissentyp={this.props.Kulissentyp}*/}
                {/*               KulissenpreisChange={this.handleKulissenpreisChange}*/}
                {/*               Optionen={this.props.Optionen}*/}
                {/*/>*/}

                {this.state.kulissenpreis > 0 ? formatEuroPrice(this.props.Rabatt > 0 ? this.rabattberechnung() : this.preisberechnung()) : <FormattedMessage id='Preis_auf_Anfrage' />}
            </strong>


        </p>
        <div className={"button-row"}>
            <button
                type="button"
                className={"download"}
                disabled={this.state.isPdfDownloadPreparing}
                onClick={this.handlePdfDownload}
            >
                <FormattedMessage id='Datenblatt' />
            </button>
            <LinkKopieren onCopy={this.props.onCopyShareLink} status={this.props.linkStatus} />
        </div>
      </div>
     </>
    );


  }
}
export default injectIntl(AusgabeKulissenwerte);
